import React from "react";
import { PacmanLoader } from "react-spinners";
import { Card, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { GetInvoiceHistory } from "../../actions/teacherQueries";
import InvoiceItem from "../../components/Invoice/InvoiceItem";

export default function TeacherInvoiceHistory() {
  const invoiceHistory = GetInvoiceHistory();

  if (invoiceHistory.isPending) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  const result = invoiceHistory.data ?? [];

  if (result.length === 0) {
    return (
      <Row>
        <Col sm="6" md="10">
          <Card body>
            <FormattedMessage id="Views.Teacher.InvoiceHistory.NoInvoicesToShow" />
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <div className="animated fadeIn">
      {result.sort((a, b) => new Date(b.created) - new Date(a.created)).map((invoice, i) => {
        return <InvoiceItem key={i} invoice={invoice} fortNoxDisplay={false} />;
      })}
    </div>
  );
}
